var ContactReportComponent = /** @class */ (function () {
    function ContactReportComponent() {
    }
    ContactReportComponent.prototype.ngOnInit = function () {
    };
    ContactReportComponent.prototype.clearActionActive = function () {
        $(".action-menu").each(function () {
            $(this).removeClass("active");
        });
    };
    ContactReportComponent.prototype.CloseModal = function (modalId) {
        $("#" + modalId).modal("hide");
        this.clearActionActive();
    };
    ContactReportComponent.prototype.create = function (event) {
        this.clearActionActive();
        event.target.classList.add("active");
        $("#createModal").modal('show');
    };
    ContactReportComponent.prototype.delete = function (event) {
        this.clearActionActive();
        event.target.classList.add("active");
        $("#deleteModal").modal('show');
    };
    ContactReportComponent.prototype.forward = function (event) {
        this.clearActionActive();
        event.target.classList.add("active");
        $("#forwardModal").modal('show');
    };
    ContactReportComponent.prototype.confirmCreate = function () {
        $("#createModal").modal('hide');
    };
    ContactReportComponent.prototype.confirmForward = function () {
        $("#forwardModal").modal('hide');
    };
    ContactReportComponent.prototype.confirmDelete = function () {
        $("#deleteModal").modal('hide');
    };
    ContactReportComponent.prototype.confirmEmail = function () {
    };
    return ContactReportComponent;
}());
export { ContactReportComponent };



// WEBPACK FOOTER //
// ./src/app/contact-report/contact-report.component.ts.pre-build-optimizer.js